import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { ArrowLeft, Check, Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function PaymentSuccess() {
    const [params] = useSearchParams();
    const sessionId = params.get("session_id");
    const [status, setStatus] = useState("pending");

    useEffect(() => {
        if (!sessionId) return;
        let tries = 0;
        let timer;
        const tick = async () => {
            tries += 1;
            try {
                const res = await fetch(`${API}/payments/status/${sessionId}`);
                const data = await res.json();
                if (data.payment_status === "paid") {
                    setStatus("paid");
                    return;
                }
            } catch (e) {
                console.error(e);
            }
            if (tries < 8) timer = setTimeout(tick, 2500);
            else setStatus("timeout");
        };
        tick();
        return () => clearTimeout(timer);
    }, [sessionId]);

    return (
        <div
            data-testid="payment-success-page"
            className="flex min-h-[80vh] items-center justify-center bg-cream px-6 pt-24"
        >
            <div className="max-w-md text-center">
                {status === "paid" ? (
                    <>
                        <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-ink text-cream">
                            <Check size={26} strokeWidth={1.5} />
                        </div>
                        <h1 className="mt-8 font-serif text-4xl font-light text-ink md:text-5xl">
                            Thank <span className="italic text-earth">you.</span>
                        </h1>
                        <p className="mt-5 text-base font-light leading-relaxed text-earth">
                            Your payment was received — a confirmation is on its
                            way to your inbox. We&apos;ll be in touch to schedule
                            your treatment or arrange your delivery.
                        </p>
                    </>
                ) : (
                    <>
                        <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full border border-clay/40 text-clay">
                            <Loader2 size={24} strokeWidth={1.5} className="animate-spin" />
                        </div>
                        <h1 className="mt-8 font-serif text-4xl font-light text-ink md:text-5xl">
                            Confirming your payment…
                        </h1>
                        <p className="mt-5 text-base font-light leading-relaxed text-earth">
                            This will only take a moment.
                        </p>
                    </>
                )}
                <Link
                    data-testid="payment-return-home-button"
                    to="/"
                    className="mt-10 inline-flex items-center gap-3 rounded-full bg-ink px-8 py-4 font-mono text-[11px] uppercase tracking-[0.25em] text-cream transition-all duration-300 hover:-translate-y-0.5 hover:bg-earth hover:shadow-xl"
                >
                    <ArrowLeft size={15} strokeWidth={1.5} />
                    Return to In Skin
                </Link>
            </div>
        </div>
    );
}

export function PaymentCancel() {
    return (
        <div
            data-testid="payment-cancel-page"
            className="flex min-h-[80vh] items-center justify-center bg-cream px-6 pt-24"
        >
            <div className="max-w-md text-center">
                <h1 className="font-serif text-4xl font-light text-ink md:text-5xl">
                    No worries —
                    <br />
                    <span className="italic text-earth">it happens.</span>
                </h1>
                <p className="mt-5 text-base font-light leading-relaxed text-earth">
                    Your payment was cancelled and nothing has been charged.
                    Whenever you&apos;re ready, we&apos;re here.
                </p>
                <Link
                    data-testid="payment-return-home-button"
                    to="/"
                    className="mt-10 inline-flex items-center gap-3 rounded-full bg-ink px-8 py-4 font-mono text-[11px] uppercase tracking-[0.25em] text-cream transition-all duration-300 hover:-translate-y-0.5 hover:bg-earth hover:shadow-xl"
                >
                    <ArrowLeft size={15} strokeWidth={1.5} />
                    Return to In Skin
                </Link>
            </div>
        </div>
    );
}
